import "@js/css";
import Alpine from "@alpinejs/csp";
import priceChart from "./content-modules/priceChart";
import { gtmPlatformLinkClicked } from "./global/gtm";
import pressCarousel from "./content-modules/pressCarousel";
import pressCarouselItem from "./content-modules/pressCarouselItem.js";
import flipCard from "./global/flipCard.js";
import languageModal from "./global/languageModal.js";
import { initStore } from "./global/store";

const params = new URLSearchParams(window.location.search);
const code = params.get("code");
const codeIsSafe = Number.isInteger(Number.parseInt(code));
const buttons = document.querySelectorAll('a[href*="app.steelcoin.com/code"]');

code &&
  codeIsSafe &&
  buttons &&
  buttons.forEach((btn) => {
    btn.href = btn.href.endsWith("/") ? btn.href + code : btn.href + "/" + code;
  });

gtmPlatformLinkClicked();

// Init global alpine store
initStore();

Alpine.data("priceChart", priceChart);
Alpine.data("pressCarousel", pressCarousel);
Alpine.data("pressCarouselItem", pressCarouselItem);
Alpine.data("flipCard", flipCard);
Alpine.data("languageModal", languageModal);

window.Alpine = Alpine;
Alpine.start();
